import React from "react"
import Helmet from "react-helmet"
import ExtendedHomepage from "src/components/extendedHomepage"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"

export default function HomePage() {
  // ExtendedHomepage expects a Promise for the data prop
  // Passing a resolved promise with empty object to use default data from JSON
  const dataPromise = Promise.resolve({})

  return (
    <HomepageLayout>
      <Helmet data={JSONData}>
        <title>Better Screenshot - Capture & Record Your Screen</title>
      </Helmet>
      <ExtendedHomepage data={dataPromise} />
      <RawFooter />
    </HomepageLayout>
  )
}

